// extracted by mini-css-extract-plugin
export default {"tooltip":"xM-z","arrow":"yM-z"};